import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  GetRiskMetricGroupCommand,
  type GetRiskMetricGroupCommandInput,
  type GetRiskMetricGroupCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';

import { apiHeliosClient, withRetry } from 'src/v2/shared/data';
import { RiskScoreQueryKeys } from './keys';

/**
 * One metric group for a single station on the live scoring day — the root KPI and its
 * sub-metric drivers. Drives the Risk Engine drill-down, fetched lazily only once a list row is
 * expanded. Keyed by the full input, so each (station, metric group, window) is cached
 * independently and a window change re-fetches rather than showing a stale panel.
 */
/**
 * The drill-down reads the daily Aurora snapshot ("as fresh as the last load"), so there's no
 * value in re-fetching a group the user already opened. A long stale time keeps a reopened (or
 * window-refocused) panel instant and flicker-free within a session.
 */
const RISK_METRIC_GROUP_STALE_TIME_MS = 10 * 60 * 1000;

export const useGetRiskMetricGroupQuery = createQuery<
  GetRiskMetricGroupCommandInput,
  GetRiskMetricGroupCommandOutput
>(
  RiskScoreQueryKeys.metricGroups,
  (input) => withRetry(() => apiHeliosClient.send(new GetRiskMetricGroupCommand(input))),
  { staleTime: RISK_METRIC_GROUP_STALE_TIME_MS },
);
